import { render, staticRenderFns } from "./channel-bind-sheet.vue?vue&type=template&id=872fa33e&scoped=true"
import script from "./channel-bind-sheet.vue?vue&type=script&lang=js"
export * from "./channel-bind-sheet.vue?vue&type=script&lang=js"
import style0 from "./channel-bind-sheet.vue?vue&type=style&index=0&id=872fa33e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "872fa33e",
  null
  
)

export default component.exports